import { Component, Input, OnInit, output, inject } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import { Fields } from 'src/app/shared/models/candidateprofile-genmodel';
import { GenModelService } from 'src/app/core/services/gen-model.service';
import { NgClass } from '@angular/common';
import { DynamicFieldComponent } from '../dynamic-field/dynamic-field.component';
@Component({
  selector: 'app-dynamic-form',
  standalone: true,
  templateUrl: './dynamic-form.component.html',
  styleUrls: ['./dynamic-form.component.scss'],
  imports: [ReactiveFormsModule, NgClass, DynamicFieldComponent],
})
export class DynamicFormComponent implements OnInit {
  private fb = inject(UntypedFormBuilder);
  private apiData = inject(GenModelService);

  @Input() fields: Fields[] = [];
  @Input() viewMode: any;
  // eslint-disable-next-line @angular-eslint/no-output-native
  readonly submit = output<any>();
  requiredBool = false;

  form: UntypedFormGroup;

  get value() {
    return this.form.value;
  }
  get validate() {
    this.form.markAllAsTouched();
    return this.form.valid;
  }

  ngOnInit() {
    this.form = this.createControl();
  }

  get reset() {
    this.apiData.setClearEvent();
    return this.form.reset();
  }

  onSubmit(event: Event) {
    console.log('form value -- ', this.form.value);
    event.preventDefault();
    event.stopPropagation();

    if (this.form.valid) {
      this.submit.emit(this.form.value);
    } else {
      this.validateAllFormFields(this.form);
    }
  }

  createControl() {
    const group = this.fb.group({});

    this.fields.sort((a, b) => a.order - b.order);
    // console.log(this.fields);
    this.fields.forEach((field) => {
      if (field.type === 50) return;
      const control = this.fb.control(field.value, this.bindValidations(field.validations || []));
      group.addControl(field.name, control);
    });
    return group;
  }

  bindValidations(validations: any) {
    // console.log("here")
    if (validations.length > 0) {
      const validList = [];
      validations.forEach((valid) => {
        switch (valid.name) {
          case 'required': {
            validList.push(Validators.required);
            break;
          }
          case 'pattern': {
            validList.push(Validators.pattern(valid.value));
            break;
          }
          case 'minlength': {
            validList.push(Validators.minLength(valid.value));
            break;
          }
          case 'maxlength': {
            validList.push(Validators.maxLength(valid.value));
            break;
          }
          case 'email': {
            validList.push(Validators.email);
            break;
          }
        }
      });
      return Validators.compose(validList);
    }
    return null;
  }

  validateAllFormFields(formGroup: UntypedFormGroup) {
    Object.keys(formGroup.controls).forEach((field) => {
      const control = formGroup.get(field);
      control.markAsTouched({ onlySelf: true });
    });
  }

  resetChipFullWidth() {
    this.apiData.resetChip();
  }
}
